export default (v: any) => v.toLowerCase().replaceAll(' ', '-');
